// Generated types for PartBreakdownTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartBreakdownTaskReadAPI extends TaskReadAPI {
}

export interface PartBreakdownTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartBreakdownTaskReadAPISchema: z.ZodType<PartBreakdownTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const PartBreakdownTaskWriteAPISchema: z.ZodType<PartBreakdownTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
